export const RESOURCES_TEXT = {
  workspace: {
    individual: 'Workspace',
    plural: 'Workspaces',
    create: 'Create Workspace',
    edit: 'Edit Workspace',
    delete: 'Delete Workspace'
  },
  meeting_room: {
    individual: 'Meeting Room',
    plural: 'Meeting Rooms',
    create: 'Create Meeting Room',
    edit: 'Edit Meeting Room',
    delete: 'Delete Meeting Room'
  },
  parking: {
    individual: 'Parking',
    plural: 'Parking',
    create: 'Create Parking',
    edit: 'Edit Parking',
    delete: 'Delete Parking'
  },
  locker: {
    individual: 'Locker',
    plural: 'Lockers',
    create: 'Create Locker',
    edit: 'Edit Locker',
    delete: 'Delete Locker'
  },
  zone: {
    individual: 'Zone',
    plural: 'Zones',
    create: 'Create Zone',
    edit: 'Edit Zone',
    delete: 'Delete Zone'
  },
  area: {
    individual: 'Zone/Floor',
    plural: 'Zones/Floors',
    create: 'Create Zone/Floor',
    edit: 'Edit Zone/Floor',
    delete: 'Delete Zone/Floor'
  }
};
